var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const Bold = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsxs("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [_jsx("title", { children: "bold" }), _jsx("path", { d: "M6.4325 19.1998V4.7998H12.1321C14.8121 4.7998 16.8314 5.72457 16.8314 8.40452C16.8314 10.0465 16.0577 11.2732 14.6988 11.6318C16.5484 11.9337 17.5675 13.1605 17.5675 15.01C17.5675 17.9919 15.3594 19.1998 12.3775 19.1998H6.4325ZM9.15019 16.7652H12.0377C13.9816 16.7652 14.8309 16.1613 14.8309 14.8024C14.8309 13.5379 14.076 12.9906 12.3397 12.9906H9.15019V16.7652ZM9.15019 10.7825H11.9622C13.3211 10.7825 14.0949 10.1408 14.0949 8.98958C14.0949 7.76285 13.3211 7.23441 11.5282 7.23441H9.15019V10.7825Z", fill: fill !== null && fill !== void 0 ? fill : COLORS.PURPLE[900] })] })));
};
